import {
  DATA_ROOM_SHAREABLE_LINK_ACCESS,
  DATA_ROOM_SHAREABLE_LINK_EXPIRES,
} from 'models/ShareableLink';

export const LINK_ACCESS = {
  [DATA_ROOM_SHAREABLE_LINK_ACCESS.ANYONE_WITH_LINK]: 'anyoneWithTheLink',
  [DATA_ROOM_SHAREABLE_LINK_ACCESS.ADD_PASSWORD]: 'requirePassword',
  [DATA_ROOM_SHAREABLE_LINK_ACCESS.SPECIFIC_RECIPIENTS]:
    'specificRecipientsOnly',
} as const;

export const EXPIRE_AFTER = {
  [DATA_ROOM_SHAREABLE_LINK_EXPIRES.SEVEN_DAYS]: '7days',
  [DATA_ROOM_SHAREABLE_LINK_EXPIRES.THIRTY_DAYS]: '30days',
  [DATA_ROOM_SHAREABLE_LINK_EXPIRES.OTHER]: 'other',
} as const;
